import React from 'react';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const TermsOfService = () => {
  useDocumentTitle('Terms of Service — Ghost Text');
  return (
    <div className="min-h-screen bg-void">
      {/* Header */}
      <div className="bg-void/85 backdrop-blur-xl border-b border-phantom/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center space-x-3">
            <img 
              src="/GhostText.png" 
              alt="Ghost Text Logo" 
              className="h-8 w-auto rounded-lg"
            />
            <span className="text-xl font-bold text-bone">Ghost Text</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-panel rounded-2xl border border-phantom/10 p-8 lg:p-12">
          <h1 className="text-4xl font-bold text-bone mb-8">
            Terms of Service
          </h1>
          
          <p className="text-lg text-mist mb-8">
            <strong>Effective Date:</strong> August 2025
          </p>

          <p className="text-lg text-mist mb-12">
            Welcome to GhostText. By using our app, you agree to these Terms of Service. Please read them carefully.
          </p>

          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                1. Local-First & Privacy-First
              </h2>
              <p className="text-mist leading-relaxed">
                GhostText is designed with privacy in mind. Your data is processed locally on your device. We do not collect, store, or transmit any user content, clipboard data, or on-screen text to our servers.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                2. Payment & Licensing
              </h2>
              <p className="text-mist leading-relaxed">
                If you purchase a license for GhostText, we only collect the minimal information required by our payment provider to process the transaction (such as your email and payment details). We do not store payment information on our servers.
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                3. License
              </h2>
              <p className="text-mist leading-relaxed">
                Each license is valid for one individual user. Redistribution, resale, or sharing of your license key is prohibited. For team or enterprise licenses, please reach out to us directly.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                4. Updates
              </h2>
              <p className="text-mist leading-relaxed">
                We may release updates to enhance security, fix bugs, or add features. To ensure the best experience, you agree to install and use the latest available version of GhostText.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                5. Limitation of Liability
              </h2>
              <p className="text-mist leading-relaxed">
                GhostText is provided "as-is" without warranties of any kind. We are not responsible for any damage or data loss resulting from your use of the app.
              </p>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-2xl font-bold text-bone mb-4">
                6. Contact
              </h2>
              <p className="text-mist leading-relaxed">
                If you have questions, need help, or want to get in touch, email us at{' '}
                <a 
                  href="mailto:support@ghosttext.app" 
                  className="text-phantom hover:text-bone underline"
                >
                  support@ghosttext.app
                </a>
                .
              </p>
            </div>
          </div>

          {/* Back to Home */}
          <div className="mt-12 pt-8 border-t border-phantom/10">
            <a 
              href="/" 
              className="inline-flex items-center space-x-2 text-phantom hover:text-bone font-medium"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              <span>Back to Home</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 